import React from "react";

const LanguageSelector = () => {
  const currentLang = localStorage.getItem("language_dsm") || "IT";

  const handleChange = (e) => {
    const selectedLang = e.target.value;
    localStorage.setItem("language_dsm", selectedLang);
    window.location.reload(); // Ricarica per applicare la lingua
  };

  return (
    <select
      value={currentLang}
      onChange={handleChange}
      style={{
        padding: "5px",
        margin: "10px",
        borderRadius: "5px",
        fontSize: "1rem",
        width: '150px'
      }}
    >
      <option value="IT">🇮🇹 Italiano</option>
      <option value="EN">🇬🇧 English</option>
    </select>
  );
};

export default LanguageSelector;
